import { defineMessages, IntlShape } from "react-intl";

import { EntityType, EntityTypeSupportingCard } from "@mapmycustomers/shared/types/entity";

enum RelationshipType {
  PARENT_COMPANY,
  CHILD_COMPANY,
  PEOPLE,
  DEALS,
  ROUTES,
}

export const COMPANY_RELATIONSHIP_TYPES = [
  RelationshipType.PARENT_COMPANY,
  RelationshipType.CHILD_COMPANY,
  RelationshipType.PEOPLE,
  RelationshipType.DEALS,
  RelationshipType.ROUTES,
];

export const PEOPLE_RELATIONSHIP_TYPES = [
  RelationshipType.PARENT_COMPANY,
  RelationshipType.DEALS,
  RelationshipType.ROUTES,
];

export const DEALS_RELATIONSHIP_TYPES = [RelationshipType.PARENT_COMPANY, RelationshipType.PEOPLE];

const addMessages = defineMessages({
  [RelationshipType.CHILD_COMPANY]: {
    id: "entityPreview.relationships.noResult.addChildCompany",
    defaultMessage: "Add Child Company",
    description: "Entity preview relationships - no result - Add Child Company",
  },
  [RelationshipType.DEALS]: {
    id: "entityPreview.relationships.noResult.addDeal",
    defaultMessage: "Add Deal",
    description: "Entity preview relationships - no result - Add Deal",
  },
  [RelationshipType.PARENT_COMPANY]: {
    id: "entityPreview.relationships.noResult.addParentCompany",
    defaultMessage: "Add Parent Company",
    description: "Entity preview relationships - no result - Add Parent Company",
  },
  [RelationshipType.PEOPLE]: {
    id: "entityPreview.relationships.noResult.addPerson",
    defaultMessage: "Add Person",
    description: "Entity preview relationships - no result - Add Person",
  },
  [RelationshipType.ROUTES]: {
    id: "entityPreview.relationships.noResult.addRoute",
    defaultMessage: "Add Route",
    description: "Entity preview relationships - no result - Add Route",
  },
});

export const getRelationshipAddMessage = (
  intl: IntlShape,
  type: RelationshipType,
  entityType: EntityTypeSupportingCard
) =>
  entityType !== EntityType.COMPANY && type === RelationshipType.PARENT_COMPANY
    ? intl.formatMessage({
        id: "entityPreview.relationships.noResult.addParentCompany.forDealsAndPeople",
        defaultMessage: "Add Company",
        description: "Entity preview relationships - no result - Add Parent Company",
      })
    : intl.formatMessage(addMessages[type]);

export default RelationshipType;
